import React from 'react'

import Form from 'components/Form'
import Header from 'Header'


export const App = () => {

  return (
    <div>
    <Header />
    <div class="form-wrapper"><Form /></div>
    </div>
  )
}
